module.exports = __webpack_public_path__ + "static/media/MONSHAAT.acc3eea5.png";